import { FormControlLabel, Switch } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox/index";
import MDTypography from "@/components/atoms/MDTypography";
import { SkuFormData } from "@/components/screens/ProductFormPage/types";
import { SkuFormMessages } from "@/messages/sku/sku-form.messages";

type Props = {
  messages: SkuFormMessages;
  isVariationProduct: boolean;
};

export default function SkuInformation({ messages, isVariationProduct }: Props) {
  const { values, handleChange, errors } = useFormikContext<SkuFormData>();
  const statusLabel = values.active ? messages.activeLabel : messages.inactiveLabel;

  return (
    <MDBox p={3} pb={0}>
      <MDBox display="flex" justifyContent="space-between">
        <MDTypography variant="h5" fontWeight={"bold"}>
          {messages.skuInformationTitle}
        </MDTypography>

        <FormControlLabel
          label={statusLabel}
          control={<Switch name="active" checked={!!values.active} onChange={handleChange} />}
        />
      </MDBox>

      <MDBox mt={1}>
        <Grid container spacing={3}>
          {isVariationProduct && (
            <Grid size={{ xs: 12, sm: 12, md: 4 }}>
              <FormField
                variant="standard"
                name="title"
                label={messages.titleLabel}
                value={values.title}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={!!errors.title}
                required
              />
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 12, md: isVariationProduct ? 4 : 6 }}>
            <FormField
              variant="standard"
              name="ean"
              label={messages.eanLabel}
              value={values.ean}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.ean}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: isVariationProduct ? 4 : 6 }}>
            <FormField
              variant="standard"
              name="code"
              label={messages.codeLabel}
              value={values.code}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.code}
              required
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
